import { images } from './';

const relatorio_content = { 
	line1: [ 
		{
			text: "É apresentada apenas na versão online, como forma de contribuir com práticas mais sustentáveis.",
			image: images.icon_relatorios_1
		},
		{
			text: "É inspirada na GRI (Global Reporting Initiative), principal metodologia internacional para relatos de sustentabilidade – versão Standard, opção essencial. <br /><br /><span className=\"gri_label\"><text>GRI 102-54</text></span>",
			image: images.icon_relatorios_2
		},
		{
			text: "Está alinhada ao padrão adotado por instituições financeiras, incluindo nossa visão estratégica com o viés da sustentabilidade.",
			image: images.icon_relatorios_3
		},
		{
			text: "Destina-se a todos os públicos de relacionamento.",
			image: images.icon_relatorios_4
		}
	],
	line2: [
		{
			text: "Apresenta o desempenho e os principais feitos de 1º de janeiro a 31 de dezembro de 2018, sem trazer mudanças significativas em porte, estrutura, cadeia de fornecedores, escopo ou limites do relatório. <br /><br /><span className=\"gri_label\"><text>GRI 102-49, 102-50</text></span>",
			image: images.icon_relatorios_5
		},
		{
			text: "Não possui revisões de informações que constavam no relatório anterior, lançado em março de 2018, referente ao ano de 2017. <br /><br /><span className=\"gri_label\"><text>GRI 102-48, 102-51</text></span>",
			image: images.icon_relatorios_6
		},
		{
			text: "Traz temas definidos sem pesquisa formal específica sobre aspectos materiais; entretanto, a nossa estratégia é elaborada a partir de consultas permanentes e pontuais aos públicos interno e externos: as prioridades estratégicas são construídas com a colaboração da Diretoria e dos associados presentes nos comitês. <br /><br /><span className=\"gri_label\"><text>GRI 102-46</text></span>",
			image: images.icon_relatorios_7
		},
		{
			text: "Inclui conteúdo retratado no <a href='http://www.anbima.com.br/pt_br/institucional/publicacoes/iniciativas/iniciativas-2018.htm' target='_blank' class='beauty-a'>Relatório de Iniciativas</a>, documento divulgado no início de dezembro com o detalhamento das principais atividades do ano.",
			image: images.icon_relatorios_8
		}
	]
};

export { relatorio_content };